import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useAddVoucherFormSchema = () => {
  const { t } = useTranslation();

  return z.object({
    voucherCode: z.string().min(1, t("common.form.field.errors.required")),
  });
};

export type TAddVoucherFormSchema = z.infer<
  ReturnType<typeof useAddVoucherFormSchema>
>;
